import wx from './wx-sdk';
import { elk } from "../report";
import { to } from '../util';

let initPromise = null;

function reset() {
  initPromise = null;
}

/**
 * jsapi初始化
 * @param  {[type]} wxConfig [description]
 * @return {[type]}          [description]
 */
function init(wxConfig) {
  //单例promise,确保只调用一次
  //如果未初始化过，那就初始化一次，如果已经初始化过，那就等待promise的reject或者resolve状态
  if (!initPromise) {
    initPromise = new Promise((resolve, reject) => {
      const wxConfigInfo = {
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxConfig.appId, // 必填，公众号的唯一标识
        timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳，注意这里的参数是timestamp ，小写的s，有些jsapi调用是大写的S
        nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
        signature: wxConfig.signature, // 必填，签名
        jsApiList: wxConfig.jsApiList // 必填，需要使用的JS接口列表
      };

      console.log('jsapi init: ', wxConfigInfo);

      const initStartTime = new Date().getTime();

      wx.config(wxConfigInfo);

      let fail = false;
      let isTimeout = false;
      let timeout = null;
      let complete = false;

      //如果失败，wx.err, wx.ready的回调都会执行（从现象来看，是wx.error先执行），所以加一个fail作为flag，如果失败，就不执行resolve
      wx.ready(function () {
        if (isTimeout) {
          return;
        }
        clearTimeout(timeout);
        if (!fail) {
          complete = true;
          //上报ready耗时
          elk({
            key: 'jsapi_init_ready_timecost',
            timeDiff: new Date().getTime() - initStartTime
          });
          resolve(true);
        } else {
          //临时上报代码，后续干掉
          elk({
            key: 'jsapi_ready_but_fail'
          });
        }
      });

      wx.error(function (res) {
        if (isTimeout) {
          return;
        }
        clearTimeout(timeout);
        fail = true;
        complete = true;

        //上报error耗时
        elk({
          key: 'jsapi_init_error_timecost',
          timeDiff: new Date().getTime() - initStartTime
        });

        reject(res.errMsg);
      });

      //超时处理，在浏览器访问会触发
      timeout = setTimeout(() => {
        if (complete) {
          return;
        }
        isTimeout = true;
        reject('jsapi init timeout');
      }, 4000);
    });
  }
  return initPromise;
}

/**
 * 获取初始化promise对象
 * @return {[type]} [description]
 */
function getInitPromiseInstance() {
  if (!initPromise) {
    //后续调用可以不带wxConfig，但是必须有一次init(wxConfig)在最前面
    throw new Error('please invoke init with wxConfig first!');
  }
  return initPromise;
}

/**
 * 拉起支付成功页面
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function getH5TransactionRequest(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise((resolve, reject) => {
    wx.invoke('getH5TransactionRequest', params, res => {
      if (/ok/.test(res.err_msg)) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

/**
 * 拉起app
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function launchApplication(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('launchApplication', params, res => {
      resolve(res);
    });
  });
}

/**
 * 获取设备支持的生物识别方式
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function getSupportSoter() {
  //这里错了就抛出吧，这样PC上调试可以通过，否则就走不下去了
  //里面的promise reject,这里await就会报错
  await getInitPromiseInstance();
  // 接口调用返回文档 ：http://x.code.oa.com/ppd-web/doc/blob/master/finger_face_pay.md
  return new Promise(resolve => {
    wx.invoke('getSupportSoter', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 请求SOTER生物认证
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
async function requireSoterBiometricAuthentication(params) {
  //这里错了就抛出吧，这样PC上调试可以通过，否则就走不下去了
  //里面的promise reject,这里await就会报错
  await getInitPromiseInstance();
  const data = {
    auth_mode: params.auth_mode,
    challenge: params.challenge
  };
  // 接口调用返回文档 ：http://x.code.oa.com/ppd-web/doc/blob/master/finger_face_pay.md
  return new Promise(resolve => {
    wx.invoke('requireSoterBiometricAuthentication', data, res => {
      const resultJson = res && res.result_json;
      // 去掉字符串中的无效字符
      if (resultJson && /\u0000/.test(resultJson)) {
        res.result_json = resultJson.replace(/\u0000/g, '');
        elk({
          key: 'requireSoterBiometricAuthentication_data_fixed',
          msg: res
        });
      }
      resolve(res);
    });
  });
}

/**
 * 隐藏所有非基础按钮
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideAllNonBaseMenuItem() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideAllNonBaseMenuItem', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 隐藏底部导航栏
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideToolbar() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideToolbar', {}, res => {
      resolve(res);
    });
  });
}

/**
 * 隐藏网页右上角按钮
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function hideOptionMenu() {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('hideOptionMenu', {}, res => {
      resolve(res);
    });
  });
}

/**
 * h5中拉起原生页面
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function openWCPaySpecificView(option) {
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('openWCPaySpecificView', option, res => {
      resolve(res);
    });
  });
}

/**
 * 关闭当前webview
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function closeWindow(param = {}) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  //await to(getInitPromiseInstance());

  return new Promise(resolve => {
    wx.invoke('closeWindow', param, res => {
      resolve(res);
    });
  });
}

/**
 * 增加自定义menu
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
async function addCustomMenuItems(params) {
  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('addCustomMenuItems', params, res => {
      resolve(res);
    });
  });
}

let wcPayWalletBufferFetchInstanse = null;
let wcPayWalletBufferSaveInstanse = null;
/**
 * 通过open-ssh生成客户端公私钥
 * fetch就是取，如果没有
 * @param   {[type]}  type          [save | fetch]
 * @param   {[type]}  walletRegion  [walletRegion description]
 * @return  {[type]}                [return description]
 */
async function handleWCPayWalletBuffer(options) {
  const type = options.type || 'fetch';
  const isFetch = (type === 'fetch');
  if (isFetch) {
    if (wcPayWalletBufferFetchInstanse) {
      return wcPayWalletBufferFetchInstanse;
    }
  } else {
    if (wcPayWalletBufferSaveInstanse) {
      return wcPayWalletBufferSaveInstanse;
    }
  }

  //这里不处理jsapi.init的错误，无论jsapi.init成功与否，都去尝试调用下面的jsapi
  await getInitPromiseInstance();
  const { privateKey, publicKey, walletRegion, wxConfigInfo } = options;
  const { appId, signType, paySign, nonceStr } = wxConfigInfo;
  console.log(
    `jsapi index handleWCPayWalletBuffer: type, privateKey, publicKey, walletRegion , ${JSON.stringify(
      options
    )}`
  );
  //let walletRegion = params.walletRegion || '8';
  const data = {
    appId,
    signType,
    timeStamp: wxConfigInfo.timestamp, //注意这里的参数是timeStamp ， 大写的S 。 wx.config中的是小写的s
    package: wxConfigInfo.package,
    paySign,
    nonceStr,
    action: type,
    walletRegion
  };

  // 设置Promise实例对象
  const setPromiseInstance = (obj) => {
    if (isFetch) {
      wcPayWalletBufferFetchInstanse = obj;
    } else {
      wcPayWalletBufferSaveInstanse = obj;
    }
  }

  if (!isFetch) {
    data.buffer = `${privateKey}^${publicKey}`;
  }

  const promise = new Promise((resolve, reject) => {
    // 超时处理
    const timeout = setTimeout(() => {
      setPromiseInstance(null);
      reject('timeout');
    }, 4000);
    wx.invoke('handleWCPayWalletBuffer', data, res => {
      window.clearTimeout(timeout);
      setPromiseInstance(null);
      console.log(
        `handleWCPayWalletBuffer  param: ${JSON.stringify(
          data
        )}, res: ${JSON.stringify(res)}`
      );

      if (/ok/.test(res.err_msg)) {
        let certInfo = null;
        //fetch的时候，才会返回buffer
        if (isFetch) {
          const info = res.buffer.split('^');
          certInfo = {
            privateKey: info[0],
            publicKey: info[1]
          };
        }
        resolve(certInfo);
      } else {
        reject(res);
      }
    });
  });
  setPromiseInstance(promise);
  return promise;
}

async function openUrlByExtBrowser(option) {
  await to(getInitPromiseInstance());
  return new Promise(resolve => {
    wx.invoke('openUrlByExtBrowser', option, res => {
      resolve(res);
    });
  });
}

export default {
  reset,
  init,
  getInitPromiseInstance,
  getSupportSoter,
  requireSoterBiometricAuthentication,
  getH5TransactionRequest,
  hideAllNonBaseMenuItem,
  hideToolbar,
  hideOptionMenu,
  closeWindow,
  launchApplication,
  addCustomMenuItems,
  handleWCPayWalletBuffer,
  openWCPaySpecificView,
  openUrlByExtBrowser
};
